'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactElement } from 'react';
import { useTranslation } from 'shared/translations';
import { INTERCOM_ARTICLE_IDS } from 'shared/constants/documentation';
import { openIntercomArticle } from 'shared/intercom';
import { TrackedBanner } from '../trackedBanner';
import { usePinterestBanner } from './usePinterestBanner';
import Image from 'public/assets/images/promoBannerPinterest.png';
const BANNER_EXPIRY_DATE = new Date(2026, 1, 28); // Feb 28, 2026 -- Overdue

export const NativePinterestBanner = t0 => {
  const $ = _c(35);
  const {
    bannerType
  } = t0;
  const {
    t
  } = useTranslation("common");
  const {
    bannerId,
    shouldShow,
    isLoading,
    dismiss
  } = usePinterestBanner();
  if (!shouldShow || isLoading) {
    return null;
  }
  let t1;
  if ($[0] !== t) {
    t1 = t("promoBanners.nativePinterestConnector.learnMoreButton");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = openIntercomArticle(INTERCOM_ARTICLE_IDS.PINTEREST);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = {
      children: t1,
      onClick: t2
    };
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const learnMoreButtonProps = t3;
  let t4;
  if ($[5] !== t) {
    t4 = t("promoBanners.nativePinterestConnector.dismissButton");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== dismiss || $[8] !== t4) {
    t5 = {
      children: t4,
      onClick: dismiss
    };
    $[7] = dismiss;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const dismissButtonProps = t5;
  if (bannerType === "home_page") {
    let t6;
    if ($[10] !== t) {
      t6 = t("promoBanners.nativePinterestConnector.tag");
      $[10] = t;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== t) {
      t7 = t("promoBanners.nativePinterestConnector.title");
      $[12] = t;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    let t8;
    if ($[14] !== t) {
      t8 = t("promoBanners.nativePinterestConnector.message");
      $[14] = t;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    let t9;
    if ($[16] !== bannerId || $[17] !== bannerType || $[18] !== dismissButtonProps || $[19] !== learnMoreButtonProps || $[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
      t9 = <TrackedBanner type="promoBanner" bannerId={bannerId} location={bannerType} image={Image.src} imageAlt="PinterestConnectorImage" tag={t6} headline={t7} content={t8} learnMoreButton={learnMoreButtonProps} dismissButton={dismissButtonProps} expiryDate={BANNER_EXPIRY_DATE} />;
      $[16] = bannerId;
      $[17] = bannerType;
      $[18] = dismissButtonProps;
      $[19] = learnMoreButtonProps;
      $[20] = t6;
      $[21] = t7;
      $[22] = t8;
      $[23] = t9;
    } else {
      t9 = $[23];
    }
    return t9;
  } else {
    let t6;
    if ($[24] !== t) {
      t6 = t("promoBanners.nativePinterestConnector.annotation");
      $[24] = t;
      $[25] = t6;
    } else {
      t6 = $[25];
    }
    let t7;
    if ($[26] !== t) {
      t7 = t("promoBanners.nativePinterestConnector.message");
      $[26] = t;
      $[27] = t7;
    } else {
      t7 = $[27];
    }
    let t8;
    if ($[28] !== bannerId || $[29] !== bannerType || $[30] !== dismissButtonProps || $[31] !== learnMoreButtonProps || $[32] !== t6 || $[33] !== t7) {
      t8 = <TrackedBanner type="banner" bannerId={bannerId} location={bannerType} variant="tip" annotation={t6} content={t7} learnMoreButton={learnMoreButtonProps} dismissButton={dismissButtonProps} expiryDate={BANNER_EXPIRY_DATE} />;
      $[28] = bannerId;
      $[29] = bannerType;
      $[30] = dismissButtonProps;
      $[31] = learnMoreButtonProps;
      $[32] = t6;
      $[33] = t7;
      $[34] = t8;
    } else {
      t8 = $[34];
    }
    return t8;
  }
};